import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  loadingPdfPreview: {
    id: 'autoCuration.pdfSplitEditor.loadingPdfPreview',
    defaultMessage: 'Loading PDF preview...',
  },
});
interface PdfLoadingStateProps {
  className?: string;
  height?: string | number;
  width?: string | number;
}

export const PdfLoadingState: React.FC<PdfLoadingStateProps> = ({
  className = '',
  height = '600px',
  width = '100%',
}) => {
  const { formatMessage } = useIntl();
  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'grey.100',
        border: 1,
        borderColor: 'grey.300',
        borderRadius: 1,
        height,
        width,
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress size={32} sx={{ mb: 2 }} />
        <Typography color="text.secondary">
          {formatMessage(messages.loadingPdfPreview)}
        </Typography>
      </Box>
    </Box>
  );
};
